var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.0673V30C15 30.5523 15.4477 31 16 31H28C28.5523 31 29 30.5523 29 30V27.1946C29 25.8988 28.3165 24.7284 27.2416 24.3163C25.7051 23.7274 23.7563 23 22 23C20.28 23 17.9859 23.6977 16.6252 24.2797C15.6165 24.7111 15 25.8365 15 27.0673Z",
    fill: "#D59829",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17C25 18.6569 23.6569 20 22 20C20.3431 20 19 18.6569 19 17C19 15.3431 20.3431 14 22 14C23.6569 14 25 15.3431 25 17Z",
    fill: "#D59829",
    fillOpacity: 0.2,
    stroke: "#C78817",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30V26.5589C15 25.4819 15.6165 24.4972 16.6252 24.1197C17.9859 23.6104 19.856 22.983 22 23C24.0957 23.0165 25.7051 23.6365 27.2416 24.1518C28.3165 24.5123 29 25.5364 29 26.6702V27.5026V28.3351V30",
    stroke: "#C78817",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.61ad94ab5dd75636b995d089264cf4c2.svg";
export { ForwardRef as ReactComponent };